import React from "react";
import { CV } from "../components/cv";
import MarcelImg from "@/assets/images/marcel.png";

export default function CVMarcelUrrutiaNilsson() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Marcel Urrutia Nilsson";
  }, []);

  return (
    <CV
      name="Marcel Urrutia Nilsson"
      photo={MarcelImg}
      title="Senior ML Engineer"
      subtitle="GenAI architecture and end-to-end delivery — from LLM backend design and prompt engineering to DevOps and stakeholder alignment."
      summary="Senior ML engineer who drives business value through honest communication, strong relationships and end-to-end ownership. Architects and delivers enterprise-grade GenAI solutions, most recently a suite of agents deployed across 30+ international markets at a global retail enterprise. Comfortable across the whole delivery chain: LLM backend design, RAG pipelines, prompt engineering, containerised deployment and technical stakeholder alignment. M.Sc. in Engineering Physics from LTH with specialisation in language technology, machine learning and AI."
      skills={{
        "AI & Machine Learning": [
          "GenAI architecture",
          "RAG pipelines",
          "NLP & LLMs",
          "Machine learning",
          "Prompt engineering",
          "Entity extraction",
        ],
        Programming: ["Python", "SQL", ".NET"],
        "Infrastructure & Tooling": ["Docker", "Kubernetes", "Linux", "Git"],
        Languages: [
          "Swedish (native)",
          "English (fluent)",
          "Danish (intermediate)",
          "Norwegian (intermediate)",
          "Spanish (basic)",
        ],
      }}
      experience={[
        {
          role: "ML Engineer & Architect (consultant)",
          company: "MurrAI Skania AB — engagement at a global retail enterprise",
          period: "Ongoing",
          description:
            "Independent consultant providing ML architecture and engineering. Architected and deployed a suite of enterprise-grade GenAI agents across 30+ international markets.",
          highlights: [
            "Owned end-to-end delivery, including LLM backend design, prompt engineering, DevOps and technical stakeholder alignment.",
          ],
        },
        {
          role: "ML Engineer (consultant)",
          company: "Nordaxon",
          period: "2023 – 2024",
          description:
            "Bridged technical pre-sales, AI strategy and hands-on ML development. Delivered solutions for clients including IKEA, Verify and Länsförsäkringar.",
        },
        {
          role: "Solutions Consultant",
          company: "TietoEvry Care",
          period: "2023",
          description:
            "Software developer building and maintaining applications using .NET and Docker.",
        },
      ]}
      education={[
        {
          degree: "M.Sc. Engineering Physics",
          institution: "Faculty of Engineering (LTH), Lund University",
          year: "2023",
        },
        {
          degree:
            "Specialisation courses: language technology, AI, computer vision, machine learning, constraint programming, agile software development",
          institution: "Lund University",
          year: "—",
        },
      ]}
      otherActivities={{
        title: "Other",
        description:
          "Educator, house renovator and dirt bike rider. Interests include climbing, slacklining, reading, programming, cooking and games. Driver's licence class B & A.",
      }}
    />
  );
}
